import React, { useState } from "react";
import { TiUserAddOutline } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import { setUserId, setUserState } from "../Store/userslice";
import { RiShareBoxLine } from "react-icons/ri";
import { BiHide, BiShowAlt } from "react-icons/bi";
import Loader from "../Loader/Loader";

const RecentPlatfrom = () => {
  const [visibleItems, setVisibleItems] = useState(5);
  const [showMore, setShowMore] = useState(false);
  //----Redux states-----
  const dispatch = useDispatch();
  const UserActivy1 = useSelector((state) => state.user.UserActivy);
  const UserActivy = UserActivy1.newActivity;
  //---------
  const getActivityTime = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp * 1000);
    const diff = Math.abs(now - activityTime);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} Day${days > 1 ? "s" : ""}`;
    }
    if (hours > 0) {
      return `${hours} Hour${hours > 1 ? "s" : ""}`;
    }
    if (minutes > 0) {
      return `${minutes} Minute${minutes > 1 ? "s" : ""}`;
    }
    return "Just now";
  };

  const userItems = UserActivy
    ? UserActivy.map((activity) => {
        const timestamp = activity?.time;
        return {
          userIcon: (
            <TiUserAddOutline
              size={35}
              className="p-2 bg-[#444] rounded-full"
            />
          ),
          user: activity?.activity,
          userId: `${activity?.userId}`,
          usedPrice: activity?.amount,
          shareIcon: <RiShareBoxLine />,
          userTime: getActivityTime(timestamp),
          tnxhash: `${activity?.txnHash}`,
        };
      })
    : [];

  const handleSetid = (e) => {
    dispatch(setUserId(e));
    dispatch(setUserState(true));
  };
  //------Share Function-----
  const handleShare = (e) => {
    window.open(`https://testnet.bscscan.com/address/${e}`, "_blank");
  };
  //-----Show More And Less Table Funtion -------
  // const toggleShowMore = () => {
  //   if (showMore) {
  //     setVisibleItems(5);
  //   } else {
  //     setVisibleItems(userItems.length);
  //   }
  //   setShowMore(!showMore);
  // };
  const [showLoader, setshowLoader] = useState(false);
  const toggleShowMore = () => {
    if (showMore) {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(4);
        setshowLoader(false);
      }, 1000);
    } else {
      setshowLoader(true);
      setTimeout(() => {
        setVisibleItems(userItems.length);
        setshowLoader(false);
      }, 1000);
    }
    setShowMore(!showMore);
  };
  return (
    <>
      <div className="recentplatfrom-main-div">
        {userItems?.slice(0, visibleItems).map((item, index) => (
          // <div key={index}>
          //   <div className="recentplatfrom-data-div">
          //     <div className="recentplatfrom-data-innerdiv">
          //       <p className="">{item.userIcon}</p>
          //       <p className="">{item.user}</p>
          //       <span
          //         className="recentplatfrom-id-div"
          //         onClick={() => handleSetid(item.userId)}
          //       >
          //         ID {item.userId}
          //       </span>
          //       <p className="">
          //         {item.usedPrice}
          //         <span className="text-purple-500">{item.subText}</span>
          //       </p>
          //     </div>
          //     <div className="recentplatfrom-time-div">
          //       <p>{item.userTime}</p>
          //       <p
          //         onClick={() => handleShare(item.tnxhash)}
          //         className="partners-table-copy-icon"
          //       >
          //         {item.shareIcon}
          //       </p>
          //     </div>
          //   </div>
          //   <hr className="border-1 py-2 border-gray-600 w-full" />
          // </div>
          <table className="tb" cellPadding={"10px"} >
            <tbody>
              <tr key={index}>
                <td className="uid">{item.userIcon} {item.user}</td>
                {/* <td>{item.user}</td> */}
                <td onClick={() => handleSetid(item.userId)}   className="recentplatfrom-id-div">
                 <span> ID {item.userId}</span>
                </td>
                <td>{item.userTime}</td>
                <td
                  onClick={() => handleShare(item.tnxhash)}
                  className="partners-table-copy-icon"
                >
                  {item.shareIcon}
                </td>
              </tr>
            </tbody>
          </table>
        ))}
        <div className="py-5">
          <div className="show-table-inner-div" onClick={toggleShowMore}>
            <span className="show-table-btn-span ">
              {showMore ? (
                <>
                  {showLoader ? (
                    <Loader />
                  ) : (
                    <>
                      See less <BiHide className="show-table-icon" />
                    </>
                  )}
                </>
              ) : (
                <>
                  {showLoader ? (
                    <Loader />
                  ) : (
                    <>
                      See more <BiShowAlt className="show-table-icon" />
                    </>
                  )}
                </>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecentPlatfrom;
